/* eslint-disable react/prop-types */
import React from 'react'
import { useTranslation } from 'react-i18next'

import './TwoButtonModal.scss'

const TwoButtonModal = ({
  title,
  subtitle,
  close,
  confirmText,
  confirmAction,
}) => {
  const { t } = useTranslation()

  return (
    <div id='TwoButtonModal'>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className='grey-out' onClick={close} />
      <div className='modal-content-2button'>
        <div className='close-button-container'>
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
          <i className='fa fa-times' aria-hidden='true' onClick={close} />
        </div>
        <div className='modal-content-box'>
          <p className='modal-title'>{title}</p>
          <p className='modal-subtitle'>{subtitle}</p>
          <div className='modal-button-box'>
            <button className='modal-cancel-button' onClick={close}>
              {t('common.cancel')}
            </button>
            <button className='modal-confirm-button' onClick={confirmAction}>
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TwoButtonModal
